<template >
  <div class="bodyback-2 min-vh-100">
    <notifications></notifications>
    <div class="overimg"></div>
    <div class="main-content">
      <div class="container">
        <div
          class="
            row row
            align-items-center
            justify-content-center
            d-flex
            vh-100
          "
        >
          <div class="col-lg-5 col-md-7">
            <div class="card mb-0">
              <div class="text-center mb-4">
                <h2 class="modal-title f-20 mt-4">
                  Welcome {{ profile.first_name }} {{ profile.last_name }}!!
                </h2>
                <h6 class="title-modal-2">Select one branch to start</h6>
              </div>

              <div class="row justify-content-center">
                <div
                  class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6"
                  v-for="(element, index) in sesion.account_type.managers"
                  :key="index"
                  @click="selectBranch(element)"
                >
                  <div class="boxBranch">
                    <i class="flaticon-organization"></i>
                    <span>{{ element.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "select-branch",
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    selectBranch(branch) {
      this.filters = this.query.split("&").filter((element) => element !== "");
      let index = this.filters.indexOf(`branch=${this.branch}`);
      if (index > -1) {
        this.setBranch(branch._id);
        let remove = this.filters.splice(index, 1);
        this.filters.push(`branch=${branch._id}`);
        this.setQuery(this.filters.join("&"));
      } else {
        this.setBranch(branch._id);
        this.filters.push(`branch=${branch._id}`);
        this.setQuery(this.filters.join("&"));
      }
      this.getReservations({});
      this.getDriversOptions(branch._id);
      this.setDriverId("");
    },
    ...mapActions([
      "getSesion",
      "getBranch",
      "getReservations",
      "getDriversOptions",
      "getProfile",
    ]),
    ...mapMutations(["setBranch", "setQuery", "setDriverId"]),
  },
  computed: {
    ...mapGetters(["branch", "sesion", "query", "profile"]),
  },
  async created() {
    this.getBranch();
    this.getSesion();
    await this.getProfile();
  },
};
</script>
